const LEVELS = { debug: 0, info: 1, warn: 2, error: 3 }

function getLevel() {
  const env = (import.meta?.env?.VITE_LOG_LEVEL || '').toLowerCase()
  const mode = (import.meta?.env?.MODE || 'development').toLowerCase()
  if (env && LEVELS[env] !== undefined) return LEVELS[env]
  return mode === 'development' ? LEVELS.debug : LEVELS.warn
}

const current = getLevel()

export const logger = {
  debug: (...args) => { if (current <= LEVELS.debug) console.debug(...args) },
  info: (...args) => { if (current <= LEVELS.info) console.info(...args) },
  warn: (...args) => { if (current <= LEVELS.warn) console.warn(...args) },
  error: (...args) => { console.error(...args) }
}

export default logger